export default "__VITE_ASSET__CTeO_KhE__"